export function isAllEarsEmail(email: string): boolean {
  return email.endsWith("@allears.ai");
}

export function isDTDGEmail(email: string): boolean {
  return email.endsWith("@synthetics.dtdg.co");
}
